module.exports = __webpack_public_path__ + "static/img/IMG_1809_00.8193f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_1809_00.png
// module id = 3Isi
// module chunks = 1